import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

// Server functions that wrap the coach-grouping database queries
// These ensure DB operations only happen on the server

export const getCoachesByCategory = createServerFn({ method: "GET" })
  .validator(z.object({ categorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachesByCategory: dbGetCoachesByCategory } =
      await import("~/lib/coach-grouping");
    return dbGetCoachesByCategory(data.categorySlug);
  });

export const getCoachesBySubcategory = createServerFn({ method: "GET" })
  .validator(z.object({ subcategorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachesBySubcategory: dbGetCoachesBySubcategory } =
      await import("~/lib/coach-grouping");
    return dbGetCoachesBySubcategory(data.subcategorySlug);
  });

export const getCoachesByCategoryAndCity = createServerFn({ method: "GET" })
  .validator(z.object({ categorySlug: z.string(), citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachesByCategoryAndCity: dbGetCoachesByCategoryAndCity } =
      await import("~/lib/coach-grouping");
    return dbGetCoachesByCategoryAndCity(data.categorySlug, data.citySlug);
  });

export const getCoachesByCity = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachesByCity: dbGetCoachesByCity } =
      await import("~/lib/coach-grouping");
    return dbGetCoachesByCity(data.citySlug);
  });

export const getCoachesBySubcategoryAndCity = createServerFn({ method: "GET" })
  .validator(z.object({ subcategorySlug: z.string(), citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachesBySubcategoryAndCity: dbGetCoachesBySubcategoryAndCity } =
      await import("~/lib/coach-grouping");
    return dbGetCoachesBySubcategoryAndCity(
      data.subcategorySlug,
      data.citySlug,
    );
  });

export const getFoundingCoaches = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getFoundingCoaches: dbGetFoundingCoaches } =
      await import("~/lib/coach-grouping");
    return dbGetFoundingCoaches();
  },
);

export const hasCoachesInCity = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { hasCoachesInCity: dbHasCoachesInCity } =
      await import("~/lib/coach-grouping");
    return dbHasCoachesInCity(data.citySlug);
  });

export const hasCoachesInCategory = createServerFn({ method: "GET" })
  .validator(z.object({ categorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { hasCoachesInCategory: dbHasCoachesInCategory } =
      await import("~/lib/coach-grouping");
    return dbHasCoachesInCategory(data.categorySlug);
  });

export const hasCoachesInSubcategory = createServerFn({ method: "GET" })
  .validator(z.object({ subcategorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { hasCoachesInSubcategory: dbHasCoachesInSubcategory } =
      await import("~/lib/coach-grouping");
    return dbHasCoachesInSubcategory(data.subcategorySlug);
  });

export const hasCoachesInCityAndSubcategory = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string(), subcategorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { hasCoachesInCityAndSubcategory: dbHasCoachesInCityAndSubcategory } =
      await import("~/lib/coach-grouping");
    return dbHasCoachesInCityAndSubcategory(
      data.citySlug,
      data.subcategorySlug,
    );
  });

export const getActiveCitySlugsWithCoaches = createServerFn({
  method: "GET",
}).handler(async () => {
  const { getActiveCitySlugsWithCoaches: dbGetActiveCitySlugsWithCoaches } =
    await import("~/lib/coach-grouping");
  return dbGetActiveCitySlugsWithCoaches();
});

export const getActiveCategorySlugsWithCoaches = createServerFn({
  method: "GET",
}).handler(async () => {
  const {
    getActiveCategorySlugsWithCoaches: dbGetActiveCategorySlugsWithCoaches,
  } = await import("~/lib/coach-grouping");
  return dbGetActiveCategorySlugsWithCoaches();
});

export const getActiveSubcategorySlugsWithCoaches = createServerFn({
  method: "GET",
}).handler(async () => {
  const {
    getActiveSubcategorySlugsWithCoaches:
      dbGetActiveSubcategorySlugsWithCoaches,
  } = await import("~/lib/coach-grouping");
  return dbGetActiveSubcategorySlugsWithCoaches();
});

export const getActiveCitySubcategoryCombinationsWithCoaches = createServerFn({
  method: "GET",
}).handler(async () => {
  const {
    getActiveCitySubcategoryCombinationsWithCoaches:
      dbGetActiveCitySubcategoryCombinationsWithCoaches,
  } = await import("~/lib/coach-grouping");
  return dbGetActiveCitySubcategoryCombinationsWithCoaches();
});
